import dynamic from "next/dynamic";
import { ReactNode } from "react";

// Dynamically import Transition only on client side to avoid build issues
// Using 'as any' to avoid type checking during build
const Transition = dynamic(
  () => import("react-transition-group").then((mod) => mod.Transition) as any,
  { ssr: false }
) as any;

type ClientTransitionProps = {
  children: (status: string) => ReactNode;
  in?: boolean;
  timeout?: number | { appear?: number; enter?: number; exit?: number };
  nodeRef?: React.RefObject<any>;
  mountOnEnter?: boolean;
  unmountOnExit?: boolean;
  onEnter?: () => void;
  onExit?: () => void;
  [key: string]: any; // Allow any other props
};

const ClientTransition = ({ children, ...props }: ClientTransitionProps) => {
  // During SSR, render children without transition
  if (typeof window === "undefined") {
    return <>{children("unmounted")}</>;
  }

  return <Transition {...props}>{children}</Transition>;
};

export default ClientTransition;
